module.exports = __webpack_public_path__ + "platform/static/media/Kundi.4f0fc5f7.png";